import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Definisci l'interfaccia Profile
export interface Profile {
  id: string;
  email: string;
  password: null;
  nome: string;
  cognome: string;
  ruolo: string;
  tipoUtente: string;
}

export interface LoginState {
  token: string;
  refreshToken: string;
  email: string;
  stayLoggedIn: boolean;
  profilo: Profile;
}

const initialState: LoginState = {
  token: "",
  refreshToken: "",
  email: "",
  stayLoggedIn: false,
  profilo: {
    id: "",
    email: "",
    password: null,
    nome: "",
    cognome: "",
    ruolo: "",
    tipoUtente: "",
  },
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLogin(
      state,
      action: PayloadAction<{
        token: string;
        refreshToken: string;
        email: string;
        stayLoggedIn: boolean;
      }>
    ) {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
      state.email = action.payload.email;
      state.stayLoggedIn = action.payload.stayLoggedIn;
    },
    setRefresh(
      state,
      action: PayloadAction<{
        token: string;
        refreshToken: string;
      }>
    ) {
      state.token = action.payload.token;
      state.refreshToken = action.payload.refreshToken;
    },
    logout(state) {
      state.token = "";
      state.refreshToken = "";
      state.email = "";
      state.stayLoggedIn = false;

      state.profilo = {
        id: "",
        email: "",
        password: null,
        nome: "",
        cognome: "",
        ruolo: "",
        tipoUtente: "",
      };
    },
    setProfilo(state, action: PayloadAction<Profile>) {
      state.profilo = action.payload;
    },
  },
});

export const { setLogin, setRefresh, logout, setProfilo } = loginSlice.actions;
export default loginSlice.reducer;
